enum EmailCompType {
  CUSTOMER = 'customer',
  DASHBOARD = 'dashboard',
}

export { EmailCompType };

